import { z } from 'zod';

export type InvitationFormSchemaValues = z.infer<typeof invitationFormSchema>;
export const invitationFormSchema = z.object({
    email: z.email().nonempty(),
    sp_role: z.string().nonempty(),
});

export type UserFormSchemaValues = z.infer<typeof userFormSchema>;
export const userFormSchema = z.object({
    user_first_name: z.string().nonempty(),
    user_last_name: z.string().nonempty(),
    sp_role: z.string().optional(),
});
